import type { RouteObject } from "react-router-dom";

export const reclaimDisputesRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Reclaim disputes monitor" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { ReclaimDisputesMonitorPage } =
            await import("./reclaim-disputes-monitor-page");
          return { Component: ReclaimDisputesMonitorPage };
        },
      },
      {
        path: "alerts",
        handle: { breadcrumb: "Alerts" },
        async lazy() {
          const { ReclaimAlertsPage } = await import("./reclaim-alerts-page");
          return { Component: ReclaimAlertsPage };
        },
      },
      {
        path: "resolve",
        handle: { breadcrumb: "Resolve" },
        async lazy() {
          const { ReclaimDeflectionsPage } =
            await import("./reclaim-deflections-page");
          return { Component: ReclaimDeflectionsPage };
        },
      },
    ],
  },
];
